<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Sites">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'" @change="onChangeSites">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
 
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDFx</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <!-- <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel> -->
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'
    import * as ExcelJS from "exceljs";
    import {
        mapState
    } from 'vuex'
    var component_x;
    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputTerminal: [],
                salesReport: [],
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                JsonData: [],
                inputTransType: 0,
                filterStatus: 0,
                transactionTypes: []
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.inputTransType = 0

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToUpperCase(data){
                let uppercasedData = data.toUpperCase();
                return uppercasedData
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    component_x.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                } else if(type == 'warning'){
                    component_x.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'daily_sales?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date, null, 'BXI-File');

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 5, 15, 15);
                    let headers = [
                        {content: 'Site', styles: {halign: 'center'}},
                        {content: 'Date', styles: {halign: 'center'}},
                        {content: 'Gross', styles: {halign: 'center'}},
                        {content: 'Less Discount', styles: {halign: 'center'}},
                        {content: 'Gross Less Discount', styles: {halign: 'center'}},
                        {content: 'Net', styles: {halign: 'center'}},
                        {content: 'Service Charge', styles: {halign: 'center'}},
                        {content: 'Tax', styles: {halign: 'center'}},
                    ]
                    let detailColStyles = {
                        0: {cellWidth: 50},
                        1: {cellWidth: 55},
                        2: {cellWidth: 30},
                        3: {cellWidth: 30},
                        4: {cellWidth: 30}, //330
                        5: {cellWidth: 30}, //330
                        6: {cellWidth: 30}, //330
                        7: {cellWidth: 30}, //330
                    }

                    for(var x=0; x < siteSpecific.length; x++){
                        let grand_gross = 0
                        let grand_less_discount = 0
                        let grand_gross_less_discount = 0
                        let grand_net = 0
                        let grand_service_charge = 0
                        let grand_vat = 0
                        this.salesReport = siteSpecific[x].report_details

                        if(x > 0 && this.salesReport.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        // report headers
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        let design_y = 25
                        doc.text(15,design_y,`Daily Sales Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
                        design_y = design_y + 10;
                        doc.text(15,design_y,"Site: " + siteSpecific[x].report_details[0].site)


                        this.salesReport = siteSpecific[x].report_details
                        // report data
                        if(this.salesReport.length > 0){
                            for(let i=0; i < this.salesReport.length; i++){
                                let reportLine = this.salesReport[i]
                                let detail = [
                                    {content: reportLine.site, styles: {halign: 'left'}},
                                    {content: moment(reportLine.business_date).format("MM-DD-YYYY"), styles: {halign: 'center'}},
                                    {content: this.convertToCurrency(Number(reportLine.gross_sales)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.less_discount)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.gross_less_discount)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.net_sales)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.service_charge)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.vat)), styles: {halign: 'right'}},
                                ]
                
                                grand_gross += Number(reportLine.gross_sales)
                                grand_less_discount += Number(reportLine.less_discount)
                                grand_gross_less_discount += Number(reportLine.gross_less_discount)
                                grand_net += Number(reportLine.net_sales)
                                grand_service_charge += Number(reportLine.service_charge)
                                grand_vat += Number(reportLine.vat)
                                reportData.push(detail)
                                
                                // let subtotal_detail = []
                                let grand_total_detail = []
                                if(i == this.salesReport.length-1){
                                    grand_total_detail = [
                                        {content: 'Total: ', styles: {fontStyle: 'bold', halign: 'left'}}, '',
                                        {content: this.convertToCurrency(grand_gross), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(grand_less_discount), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(grand_gross_less_discount), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(grand_net), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(grand_service_charge), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(grand_vat), styles: {fontStyle: 'bold'}}
                                    ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(grand_total_detail)

                                    //create table
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [headers],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    // subtotal = 0
                                    // grand_total = 0
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    let pageCount = doc.internal.getNumberOfPages();
                    let footer_x = 340
                    let footer_y = 205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Daily Sales Report", footer_x, footer_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Daily Sales Report", {
                    pageSetup:{paperSize: 9}
                });

                this.spinning = true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('YYYY-MM-DD');
                let to_header= this.inputDate[1].format('YYYY-MM-DD');

                let printed_by = secureStorage.getItem("email")
                if(printed_by == null){
                    printed_by = ''
                }
                const data_starts_at_row = 7

                let site_text = '';
                if(this.inputSite.length == 0){
                    site_text = 'All Sites'
                } else {
                    let sites = this.inputSite
                    for (var s = 0; s < sites.length; s++) {
                        if(s == 0){
                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                        } else {
                            site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                        }
                    }
                }

                sheet.getRow(2).values = [`Site: ${site_text}`];
                sheet.getRow(3).values = ["Daily Sales Report"]
                sheet.getRow(4).values = [`For the Period of ${from_header} to ${to_header}`]
                sheet.getRow(5).values = [`Generated by: ${printed_by}`]
            
                //custom header
                let header_arr = []
                header_arr.push("Site", "Date", "Gross", "Less Discount", "Gross Less Discount", "Net", "Service Charge", "Tax")
                let row_arr = []
                row_arr.push({ key: "site" , width: 20 },
                    {key: "business_date" , width: 20 },
                    { key: "gross", width: 15, style: { numFmt: '0.00' }},
                    { key: "less_discount" , width: 20 },
                    { key: "gross_less_discount", width: 15 },
                    { key: "net_sales", width: 15 },
                    { key: "service_charge", width: 15 },
                    { key: "vat", width: 15 },
                )
                sheet.getRow(data_starts_at_row).values = header_arr;
                sheet.columns = row_arr;

                // var report_details = this.JsonData
                var report_details = this.JsonData.filter(item => item.Site !== "Daily Sales Report");
                console.log('report_details')
                console.log(report_details)
                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < report_details.length; i++){
                    const report_detail = report_details[i]
                    if(report_detail){
                        let rowData =  {"site": report_detail["Site"], 
                        "business_date": report_detail["Date"],
                        "gross": report_detail["Gross"],
                        "less_discount": report_detail["Less Discount"],
                        "gross_less_discount": report_detail["Gross Less Discount"],
                        "net_sales": report_detail["Net"],
                        "service_charge":report_detail["Service Charge"],
                        "vat": report_detail["Tax"]}
                        rowDatas.push(rowData)
                    }
                }
                sheet.addRows(rowDatas);
                sheet.getRow(3).font = { bold: true};
                sheet.getRow(data_starts_at_row).font = { bold: false };
                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `dailySalesReport.xlsx`);
                });
                this.JsonData = []
                this.spinning = false;
            },
            generateFile: async function() {
                this.spinning = true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('YYYY-MM-DD');
                let to_header= this.inputDate[1].format('YYYY-MM-DD');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'daily_sales?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date, null, 'BXI-File');
                if(get_request.error) {
                    this.openNotificationWithIcon('warning', get_request.error);
                    return
                }
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ["Site", "Date", "Gross", "Less Discount", "Gross Less Discount", "Net", "Service Charge", "Tax"];
                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        let reportData = [];
                        if(x > 0){
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let total_gross = 0
                            let total_less_discount = 0
                            let total_gross_less_discount = 0
                            let total_net = 0
                            let total_service_charge = 0
                            let total_vat = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let detail_header = [];
                                let detail = []
                                detail = [
                                    reportLine.site,
                                    reportLine.business_date,
                                    this.convertToCurrency(Number(reportLine.gross_sales)),
                                    this.convertToCurrency(Number(reportLine.less_discount)),
                                    this.convertToCurrency(Number(reportLine.gross_less_discount)),
                                    this.convertToCurrency(Number(reportLine.net_sales)),
                                    this.convertToCurrency(Number(reportLine.service_charge)),
                                    this.convertToCurrency(Number(reportLine.vat))];

                                total_gross += Number(reportLine.gross_sales)
                                total_less_discount += Number(reportLine.less_discount)
                                total_gross_less_discount += Number(reportLine.gross_less_discount)
                                total_net += Number(reportLine.net_sales)
                                total_service_charge += Number(reportLine.service_charge)
                                total_vat += Number(reportLine.vat)

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                let grand_detail = []
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    sub_detail = []
                                    grand_detail = []

                                    sub_detail.push('Total :', '', this.convertToCurrency(total_gross), this.convertToCurrency(total_less_discount),
                                        this.convertToCurrency(total_gross_less_discount), this.convertToCurrency(total_net),
                                        this.convertToCurrency(total_service_charge), this.convertToCurrency(total_vat)
                                    );
                                    reportData.push(Object.assign({}, sub_detail))  
                                } 
                            }
                        }
                        // reportData.unshift([site_text]);
    
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push(['', '', '', '', '', '', '', ''])
                        reportData.push(['', '', '', '', '', '', '', ''])
                        reportData.push(["Daily Sales Report", "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header, "", "", "", "", ""])
                        reportData.push(['', '', '', '', '', '', '', ''])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            })));
                            newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            clearJsonData(){
                this.JsonData = [];
            },
            async onChangeSites(value){
                let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + value, null);
                this.terminalOptions = terminals;
                this.sort(this.terminalOptions);
            }
        }
    };
</script>

<style></style>